import { render, staticRenderFns } from "./downloadMsg.vue?vue&type=template&id=18bf378f&scoped=true&lang=html&"
import script from "./downloadMsg.vue?vue&type=script&lang=js&"
export * from "./downloadMsg.vue?vue&type=script&lang=js&"
import style0 from "./downloadMsg.vue?vue&type=style&index=0&id=18bf378f&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18bf378f",
  null
  
)

component.options.__file = "downloadMsg.vue"
export default component.exports